import type { ReactNode } from "react";
import { useCadForm } from "./formContext";

export interface FieldProps { label: string; htmlFor: string; unit?: string; symbol?: string; error?: string; hint?: string; children: ReactNode; /** etiket yalnız ekran okuyucuya (çizim içi yerinde düzenleme) */ hideLabel?: boolean }

export function Field({ label, htmlFor, unit, symbol, error, hint, children, hideLabel, hot }: FieldProps & { /** ilgili ölçü vurgulu (CAD satırı sarı) */ hot?: boolean }): JSX.Element {
  const cad = useCadForm();
  if (cad && !hideLabel) {
    // Özellik ızgarası satırı: etiket | değer + birim; hata satır altında, ipucu etiket başlığında
    return (
      <div className="cad-prop-row" data-hot={hot || undefined} data-error={error ? "true" : undefined}>
        <label htmlFor={htmlFor} className="cad-prop-label" title={hint ? `${label} — ${hint}` : label}>{label}{symbol ? <span className="ml-1 font-mono text-cad-ink4">{symbol}</span> : null}</label>
        <div className="cad-prop-value">{children}{unit ? <span className="cad-prop-unit">{unit}</span> : null}</div>
        {error ? <p role="alert" id={`${htmlFor}-err`} className="cad-prop-error">{error}</p> : null}
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={htmlFor} className={hideLabel ? "sr-only" : "flex items-baseline justify-between text-xs text-ink/75"}>
        <span>{label}{symbol ? <span className="ml-1 font-mono text-stone">{symbol}</span> : null}</span>
        {unit ? <span className="font-mono text-stone">{unit}</span> : null}
      </label>
      {children}
      {error ? <p role="alert" id={`${htmlFor}-err`} className="text-xs text-bad">{error}</p> : hint ? <p className="text-xs text-stone">{hint}</p> : null}
    </div>
  );
}
